/**
 * The report panel type and the settings it draws from.
 */

const report = {
  /* Born document-shaped rather than full width: the body caps its line length for readability, so a
     twelve-column card left roughly 650px of the card empty while the prose scrolled three screens
     inside it. Six columns puts the card and the reading measure at about the same width. Measured
     on the grid, not guessed. Still freely resizable — this is a creation size, not a pinned one. */
  names: [{ id: 'report', label: 'Report', phrase: 'a report', guide: 'report.md', companionGuides: ['report-ai-snippets.md'], advanced: true, creationLayout: { w: 6, h: 10 }, toolSummary: 'a written narrative about the data, authored as markdown by the transform', promptSummary: 'a written narrative authored as markdown by the transform — the prose around the numbers, for a reader who wants the reasoning rather than the marks' }],
  block: 'report',
  /* Report. One column of the first row holds the whole document, the same shape as the html panel's
     body key. There is no field for the format: the column is markdown. A type that also accepted
     custom HTML would be two authoring languages behind one name, and html is already that name.
     `required` and `clearable` together are not a contradiction: a caller that sends this block has
     to name the column, and a caller that wants the conventional one omits the block entirely.
     `clearable` is the editor's way back to that state once a column has been picked. */
  fields: {
    key: { kind: 'string', required: true, clearable: true, hint: 'the whole document lives in one column of the first row', label: 'Report column' }
  },
  editorHint: "One row is one report: the first row's value at this column is the whole document, written as markdown by the transform. A column named report is picked up automatically.",
  /* Guarded on the type, not just the block: the per-turn context walks every block a panel could
     carry, so an unguarded summary appends itself to other types' display lines. Named even before
     a column is chosen, because the default is what the panel will read. */
  stateSummary: ({ block, type }) => (type === 'report' ? `report: body key ${block.key || 'report'}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['key'],
    description: 'Report panel mapping (displayType "report"): the FIRST data row\'s value at this key is the ENTIRE panel body — one markdown document the transform writes from the data. Omit the WHOLE block (or send null) to fall back to a column named "report"; sending the block without naming a column is rejected. The panel renders markdown only and cannot draw a chart: build the chart as its own panel beside the report and refer to it in the prose. MANDATORY before authoring: knowledge_read immutable/analytics/panel-types/report.md.',
    properties: {
      /* No dot paths, deliberately: this reads one column of one row the same way the html panel
         does, and neither renderer walks a path. Types that promise dot paths back it with a
         reducer; promising it here without one would be a contract the code does not keep. */
      key: { type: 'string', description: "Column holding the report's markdown document." }
    }
  }
};

export default report;
